import { useQuery } from '@tanstack/react-query'
import { createClient } from '@wallyhealth/web-core'
import { chain, prop } from 'ramda'
import config from '../config'

const client = createClient({ baseUrl: config.PROVIDER_KAPI_URL })

export const useGeos = () => {
  const query = () => {
    return client.get('/locations/public-geos')
      .then(response => response.data)
  }

  const { data, isLoading } = useQuery({
    queryKey: ['fetchPublicGeoLocations'],
    queryFn: query
  })

  const geos = data || []

  return {
    geos,
    locations: chain(prop('locations'), geos),
    isLoadingGeos: isLoading
  }
}

export default useGeos
